module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "c-card--orders__single__order-number card-subcontainer"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.order_number', {
    order_number: _vm.order.short_order_id
  })))]), _vm._v(" "), _c('div', {
    staticClass: "c-card--orders__single__datagroup order-info-group"
  }, [_c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.date')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v(_vm._s(_vm.order.created))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.points')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v("\n        " + _vm._s(_vm.order.order_total) + "\n      ")])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.quantity')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_vm._v(_vm._s(_vm.order.item_quantity))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-card--orders__single__data"
  }, [_c('dt', {
    staticClass: "c-card--orders__single__data__label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.order_status')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-card--orders__single__data__value"
  }, [_c('span', {
    staticClass: "c-status",
    class: _vm.statusColor(_vm.order.order_status)
  }, [_vm._v(_vm._s(_vm.order.order_status))])])])]), _vm._v(" "), _vm._l((_vm.order.line_items), function(lineItem) {
    return _c('div', {
      key: lineItem.id,
      staticClass: "card-subcontainer"
    }, [_c('p', {
      staticClass: "c-card--orders__single__item"
    }, [_c('router-link', {
      staticClass: "t-link",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: lineItem.item.id
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(lineItem.item.name) + "\n      ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "c-card--orders__single__datagroup"
    }, [_c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.line_item')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_vm._v(_vm._s(lineItem.line_item_number))])]), _vm._v(" "), _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.points')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_c('i', {
      staticClass: "fa fa-star t-points-icon"
    }), _vm._v("\n          " + _vm._s(lineItem.line_item_points_amount_charged) + "\n        ")])]), _vm._v(" "), _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.updated')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_vm._v(_vm._s(lineItem.updated_at))])]), _vm._v(" "), _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.order_status')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_c('span', {
      staticClass: "c-status",
      class: _vm.statusColor(lineItem.line_item_order_status)
    }, [_vm._v(_vm._s(lineItem.line_item_order_status))])])])]), _vm._v(" "), _c('div', {
      staticClass: "c-card--orders__single__datagroup"
    }, [(!lineItem.email_status) ? _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.shipping_status')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_c('span', {
      staticClass: "c-status",
      class: _vm.statusColor(lineItem.line_item_shipping_status)
    }, [_vm._v(_vm._s(lineItem.line_item_shipping_status))])])]) : _vm._e(), _vm._v(" "), (!lineItem.email_status) ? _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [(lineItem.item.item_type.redemption_flow.toLowerCase() === 'digital confirmation') ? _c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.travel_certificate')))]) : _c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.tracking')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_vm._v("\n          " + _vm._s(lineItem.carrier_tracking) + "\n          "), (!lineItem.carrier_tracking) ? _c('span', {
      staticClass: "c-card--orders__single__data__value__empty"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.tracking_unavailable')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (lineItem.email_status) ? _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.email_delivery_status')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_vm._v("\n          " + _vm._s(lineItem.email_status) + "\n        ")])]) : _vm._e(), _vm._v(" "), (lineItem.email_status) ? _c('dl', {
      staticClass: "c-card--orders__single__data"
    }, [_c('dt', {
      staticClass: "c-card--orders__single__data__label"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.email_engagement_status')))]), _vm._v(" "), _c('dd', {
      staticClass: "c-card--orders__single__data__value"
    }, [_vm._v("\n          " + _vm._s(lineItem.email_engagement_event) + "\n          "), (!lineItem.email_engagement_event) ? _c('span', {
      staticClass: "c-card--orders__single__data__value__empty"
    }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_list.tracking_unavailable')))]) : _vm._e()])]) : _vm._e()])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00114274"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/CatalogOrderCard.vue
// module id = 506
// module chunks = 1